import React, {Component} from "react";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import RemotingService from "../../../../../services/remoting-service/RemotingService";
import ClaimStatusEnum from "./ClaimStatus";
import DateUtil from "../../../../../utils/DateUtil";


export default class ClaimStatusLogModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: []
        };
    }

    componentDidMount() {
        RemotingService.getRemoteCall(
            `api/insurance/coordinator/v2/claims/claim/${this.props.claimId}/status-log`,
            null,
            (items) => {
                this.setState({items: items});
            });
    }

    statusName(status) {
        return status && ClaimStatusEnum[status] ? ClaimStatusEnum[status].name : status;
    }

    render() {
        return (
            <div style={{width: 600, padding: "20px"}}>
                <DataTable responsive emptyMessage={"No status changes found"}
                           value={this.state.items}>
                    <Column header="Date/Time" body={item => item.changedAt ? DateUtil.formatDateTime12H(item.changedAt) : ''}/>
                    <Column header="Changed By" field="changedBy"/>
                    <Column header="Old Status" body={item => this.statusName(item.oldStatus)}/>
                    <Column header="New Status" body={item => this.statusName(item.newStatus)}/>
                </DataTable>
            </div>
        );
    }
}
